export default "__VITE_ASSET__CRwkkVv6__"